var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnAlert = function SvgIcnAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.5 50.5",
    style: {
      enableBackground: "new 0 0 50.5 50.5"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,16.7c0.7-3.8,2.4-7.2,5-9.9c0.8-0.8,0.7-2-0.1-2.8c-0.8-0.8-2-0.7-2.8,0.1c-3.1,3.3-5.2,7.4-6,12 c-0.2,1.1,0.5,2.1,1.6,2.3c0.1,0,0.2,0,0.4,0C5.5,18.3,6.3,17.7,6.5,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.2,33.1c-0.1,0-1.6-0.7-2.8-2.1c-0.7-0.9-1.9-1-2.8-0.3c-0.9,0.7-1,1.9-0.3,2.8c1,1.3,2.2,2.1,3.1,2.7 c-0.2,0.8-0.5,1.8-1,2.6c-0.9,1.3-2.1,1.9-3.8,1.9H13.5c-3.1,0-4.4-2.6-4.8-4.5c0.6-0.3,1.3-0.8,2-1.4c2.2-2,3.4-4.7,3.4-7.7 v-6.9c0-6.2,5-11.4,11.2-11.4c0,0,0,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c6.3,0.1,11.3,5.2,11.3,11.4v2.8 c0,1.1,0.9,2,2,2s2-0.9,2-2v-2.8c0-7.8-6-14.4-13.6-15.3V2c0-1.1-0.9-2-2-2s-2,0.9-2,2v2.9c-3.4,0.4-6.5,2-8.9,4.5 c-2.9,2.9-4.4,6.7-4.4,10.8V27c0,4.4-4,6-4.2,6.1c-0.8,0.3-1.3,1-1.3,1.9c0,2.1,0.7,4.3,2,6.1c1.6,2.3,4.1,3.6,6.9,3.6h6.1 c0,3.3,2.7,5.9,5.9,5.9s5.9-2.7,5.9-5.9h6.1c3.8,0,5.9-1.9,7-3.6c1.7-2.4,1.8-5,1.8-6C46.5,34.1,46,33.4,45.2,33.1z M25.6,46.6 c-1.1,0-2-0.9-2-2h3.9C27.5,45.7,26.7,46.6,25.6,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.4,16.1c-0.8-4.6-3-8.9-6.1-12.1c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8c2.6,2.7,4.4,6.2,5.1,10.1 c0.2,1,1,1.6,1.9,1.6c0.1,0,0.2,0,0.4,0C47.9,18.2,48.6,17.2,48.4,16.1z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_alert.bd63ff99.svg";
export { ForwardRef as ReactComponent };